import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import * as validations from 'stash/utils/formValidations';
import {
	Text,
	PrimaryButton,
	Fieldset,
	Legend,
	FormWrapper,
	FormikTextInput,
	Link as StashUILink,
} from '@stashinvest/ui';

const emailSchema = Yup.object().shape({
	user: Yup.object().shape({
		email: validations.yupEmailValidation(),
		password: Yup.mixed().required('A password is required'),
	}),
});

const emailInitialValues = {
	user: {
		email: '',
		password: '',
	},
};

const EmailPasswordLogin = (props) => {
	return (
		<Formik
			validationSchema={emailSchema}
			initialValues={emailInitialValues}
			onSubmit={(values, actions) => {
				props.onSubmit(values).catch((resp) => {
					actions.setFieldError('user.password', resp.message);
					actions.setSubmitting(false);
				});
			}}
		>
			{(formikProps) => (
				<FormWrapper mt="l">
					<Form noValidate>
						<Fieldset p="0" mb="l">
							<Legend screenReaderOnly>
								<p>Welcome. Log in to Stash to access your cash and investments.</p>
							</Legend>
							<FormikTextInput name="user.email" type="email" label="Email" />
							<FormikTextInput name="user.password" type="password" label="Password" />
							<PrimaryButton loading={formikProps.isSubmitting} type="submit">
								Log in
							</PrimaryButton>
						</Fieldset>
						<Text.BodySmall mb="m">
							<Link to="/forgot-password">Forgot password?</Link>
							<span> | </span>
							<StashUILink href="/sign-up" data-test="sign-up-link">
								Create account
							</StashUILink>
						</Text.BodySmall>
						<Text.Caption>
							<span>By using our website, you agree to our </span>
							<a
								href="https://lp.stash.com/terms-of-use"
								target="_blank"
								rel="noopener noreferrer"
							>
								Terms of Use
							</a>
							<span> and </span>
							<a
								href="https://www.stash.com/theprivacypolicy"
								target="_blank"
								rel="noopener noreferrer"
							>
								Privacy Policy
							</a>
						</Text.Caption>
					</Form>
				</FormWrapper>
			)}
		</Formik>
	);
};

EmailPasswordLogin.propTypes = {
	onSubmit: PropTypes.func,
	query: PropTypes.object,
};

export default EmailPasswordLogin;
